import type { Size } from '@interstate/components/SelectInput';
import { useMediaQuery } from 'react-responsive';
import type { InterstateTheme } from '@interstate/components/InterstateThemeProvider';

export const responsiveFieldSx = {
    mb: 2,
    '& .ids-combo-box-input-and-chips': {
        gap: 0
    },
    '& .ids-combo-box-multi-select-input': {
        maxHeight: 150
    },
    '& .MuiPopper-root': {
        '& .MuiPaper-root': {
            maxWidth: 'min(25rem, 90vw)'
        }
    },
    width: '100%'
};

export const commonSelectFieldProps = {
    displayDeselectOption: false,
    size: 'small' as Size,
    maxListBoxHeight: 200,
    sx: responsiveFieldSx
};

export const useResponsiveGrid = (theme: InterstateTheme) => {
    const isLargeSize = useMediaQuery({
        query: `(min-width: ${theme.tokens.BaseScreenLg})`
    });

    return {
        display: 'grid',
        gap: '0 1rem',
        gridTemplateColumns: isLargeSize ? 'repeat(3, 1fr)' : 'repeat(2, 1fr)',
        gridTemplateRows: isLargeSize ? 'repeat(2, auto)' : 'repeat(3, auto)',
        '& > *': {
            minWidth: 0,
            maxWidth: '100%'
        }
    };
};
